import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons
import "../CSS/Footer.css"; // Import custom CSS

const Footer = () => {
    const [subscribeMsg, setSubscribeMsg] = useState("");
    const socialIcons = [
        { icon: "bi bi-facebook", link: "https://www.facebook.com/share/1BCASFDLVD/" },
        { icon: "bi bi-whatsapp", link: "https://wa.me/+66925528900" },
        { icon: "bi bi-instagram", link: "https://www.instagram.com/skymytravelth?igsh=MWJqaWVvbXQ3ZWp3Yw==" }
    ];

    const handleSubscribe = (event) => {
        event.preventDefault();
        setSubscribeMsg("Thank you for subscribing!");
        setTimeout(() => setSubscribeMsg(""), 3000);
    };

    return (
        <footer className="custom-footer">
            <div className="container">
                <div className="footer-grid">
                    {/* Get in Touch Section */}
                    <div className="footer-column">
                        <h5>Get in Touch</h5>
                        <p>Skymy Travel</p>
                        {/* <form onSubmit={handleSubscribe} className="subscribe-form">
                            <input type="email" placeholder="Enter your email" required />
                            <button type="submit">Subscribe</button>
                        </form>
                        {subscribeMsg && <p className="subscribe-msg">{subscribeMsg}</p>} */}
                    </div>

                    {/* Download Section */}
                    {/* <div className="footer-column">
                        <h5>Download</h5>
                        <ul>
                            {["Company", "Android App", "iOS App", "Desktop", "Projects", "My tasks"].map((item, index) => (
                                <li key={index}><a href="#">{item}</a></li>
                            ))}
                        </ul>
                    </div> */}

                    {/* Help Section */}
                    <div className="footer-column">
                        <h5>Help</h5>
                        <ul>
                            {["FAQ", "Terms & Conditions", "Reporting", "Documentation", "Support Policy", "Privacy"].map((item, index) => (
                                <li key={index}><a href="#">{item}</a></li>
                            ))}
                        </ul>
                    </div>

                    {/* Social Media Section */}
                    <div className="footer-column">
                        <h5>Follow Us</h5>
                        <div className="social-icons">
                            {socialIcons.map((social, index) => (
                                <a href={social.link} key={index} className="social-icon">
                                    <i className={social.icon}></i>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Copyright Section */}
            {/* <div className="footer-bottom">
                <p>&copy; 2024 Skymy Travel. All rights reserved.</p>
            </div> */}
        </footer>
    );
};

export default Footer;
